document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let topContentSlider = new Swiper('.top-content__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });

    let sliderExtra = new Swiper('.slider__one',{
        speed: 1000,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 5,
        loop: true,
        effect: 'fade',
            fadeEffect: {
            crossFade: true
        }
    });

    let sliderExtra2 = new Swiper('.slider__two',{
        speed: 1000,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 5,
        loop: true,
        allowTouchMove: false,
        effect: 'fade',
            fadeEffect: {
            crossFade: true
        }
    });

    let sliderImages = new Swiper('.slider__slider-images',{
        speed: 1000,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 5,
        loop: true,
        allowTouchMove: false,
        effect: 'fade',
            fadeEffect: {
            crossFade: true
        }
    });

    let sliderText = new Swiper('.slider__slider-text',{
        speed: 700,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next'
        },
        effect: 'fade',
            fadeEffect: {
            crossFade: true
        }
    });

    const breakpoint = window.matchMedia('(max-width: 600px)');

    function handleTabletChange(e) {
        if (e.matches) {
            sliderText.controller.control = [sliderImages, sliderExtra2];
        } else {
            sliderText.controller.control = [sliderExtra,sliderImages,sliderExtra2];
        }
    }

    breakpoint.addEventListener('change', handleTabletChange);
    handleTabletChange(breakpoint);

    let quadReviews = new Swiper('.reviews__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next'
        }
    });

    let galleryCustom = new Swiper('.gallery-custom__slider',{
        speed: 1000,
        loop:true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.gallery-custom-prev',
            nextEl: '.gallery-custom-next'
        }
    });

    let galleryMobile = new Swiper('.gallery-custom__slider-mobile',{
        speed: 1000,
        loop:true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.gallery-custom-prev',
            nextEl: '.gallery-custom-next'
        }
    })

    if(document.querySelector('section.accommodations-quad')){
        document.querySelectorAll('.accommodations-quad__slider').forEach((element, i) => {
            let entryId = element.getAttribute('data-entry');
            element.setAttribute(`data-room-swiper-${i}`, "");
            let swiper = new Swiper(`[data-room-swiper-${i}]`,{
                loop: true,
                speed: 700,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    prevEl: `.rooms-${entryId}-prev`,
                    nextEl: `.rooms-${entryId}-next`
                }
            });
        });
    }

    let cardsSlider = new Swiper('.cards-slider__slider',{
        speed: 700,
        loop: true,
        spaceBetween: 20,
        navigation: {
            prevEl: '.cards-slider-prev',
            nextEl: '.cards-slider-next'
        },
        breakpoints: {
            600: {
                slidesPerView: 1
            },
            760: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 3
            }
        }
    });

});